/**
 * @generated SignedSource<<1805cd2023e67b544e7acb1541ec57dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type datalevel = "CJIS" | "EXTERNAL" | "INTERNAL" | "PRESALE" | "SECRET" | "TRIAL" | "UNKNOWN" | "%future added value";
export type orgtier = "BETA" | "EMPLOYEE" | "PROTECTED" | "T1" | "T2" | "T3" | "UNKNOWN" | "%future added value";
export type CreateOrganizationModalMutation$variables = {
  dataLevel?: datalevel | null;
  name: string;
  orgTier?: orgtier | null;
  salesforceAccountId?: string | null;
  templateOrgUuid?: string | null;
  validateFieldsAgainstSalesforce: boolean;
};
export type CreateOrganizationModalMutation$data = {
  readonly createOrganization: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly organization: {
      readonly id: string;
      readonly name: string;
      readonly orgTier: orgtier | null;
      readonly uuid: string;
    } | null;
  } | null;
};
export type CreateOrganizationModalMutation = {
  response: CreateOrganizationModalMutation$data;
  variables: CreateOrganizationModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dataLevel"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgTier"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "salesforceAccountId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateOrgUuid"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "validateFieldsAgainstSalesforce"
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dataLevel",
        "variableName": "dataLevel"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "orgTier",
        "variableName": "orgTier"
      },
      {
        "kind": "Variable",
        "name": "salesforceAccountId",
        "variableName": "salesforceAccountId"
      },
      {
        "kind": "Variable",
        "name": "templateOrgUuid",
        "variableName": "templateOrgUuid"
      },
      {
        "kind": "Variable",
        "name": "validateFieldsAgainstSalesforce",
        "variableName": "validateFieldsAgainstSalesforce"
      }
    ],
    "concreteType": "CreateOrganization",
    "kind": "LinkedField",
    "name": "createOrganization",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uuid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "orgTier",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateOrganizationModalMutation",
    "selections": (v6/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateOrganizationModalMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "5707b691dcbea2c9e32e6283aa5670a8",
    "id": null,
    "metadata": {},
    "name": "CreateOrganizationModalMutation",
    "operationKind": "mutation",
    "text": "mutation CreateOrganizationModalMutation(\n  $name: String!\n  $dataLevel: datalevel\n  $orgTier: orgtier\n  $templateOrgUuid: String\n  $salesforceAccountId: String\n  $validateFieldsAgainstSalesforce: Boolean!\n) {\n  createOrganization(name: $name, dataLevel: $dataLevel, orgTier: $orgTier, templateOrgUuid: $templateOrgUuid, salesforceAccountId: $salesforceAccountId, validateFieldsAgainstSalesforce: $validateFieldsAgainstSalesforce) {\n    organization {\n      id\n      uuid\n      name\n      orgTier\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "3379bbf5fe4b363d939f8543f19660d0";

export default node;
